module.exports = __webpack_public_path__ + "img/stateGreen.ed69e87b.png";